import { CheckIcon, XIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

interface PasswordRequirementsChecklistProps {
    password: string;
}

export const PasswordRequirementsChecklist = ({
    password,
}: PasswordRequirementsChecklistProps) => {
    const { t } = useTranslation();

    const requirements = [
        {
            id: "length",
            label: t("components.register-form.password-min-length"),
            validate: (pwd: string) => pwd.length >= 6,
        },
        {
            id: "lowercase",
            label: t("components.register-form.password-lowercase"),
            validate: (pwd: string) => /[a-z]/.test(pwd),
        },
        {
            id: "uppercase",
            label: t("components.register-form.password-uppercase"),
            validate: (pwd: string) => /[A-Z]/.test(pwd),
        },
        {
            id: "digit",
            label: t("components.register-form.password-digit"),
            validate: (pwd: string) => /[0-9]/.test(pwd),
        },
        {
            id: "special",
            label: t("components.register-form.password-special"),
            validate: (pwd: string) => /[^a-zA-Z0-9]/.test(pwd),
        },
    ];

    return (
        <ul className="mt-2 space-y-1 text-xs">
            {requirements.map((requirement) => {
                const isValid = requirement.validate(password);
                return (
                    <li
                        className={cn(
                            "flex items-center gap-2",
                            isValid ? "text-green-600" : "text-red-500",
                        )}
                        key={requirement.id}
                    >
                        {isValid ? (
                            <CheckIcon className="h-3 w-3" />
                        ) : (
                            <XIcon className="h-3 w-3" />
                        )}
                        <span>{requirement.label}</span>
                    </li>
                );
            })}
        </ul>
    );
};
